export enum EventStatus {
    Unconfirmed = 0,
    Waiting = 1,
    Verified = 2,
    Deleted = 3,
}